import { twMerge } from "tailwind-merge";
import { Button } from "@shared/ui/Button";
import { GoogleButton } from "@shared/ui/GoogleButton";

type Props = {
  onSubmit: () => void;
  onSubmitWithGoogle: () => void;
  isSubmitting: boolean;
  isLoading: boolean;
  isValid: boolean;
  submitLabel: string;
  googleLabel: string;
  isWithBorder?: boolean;
  isWithPadding?: boolean;
  className?: string;
  signupButtonClassName?: string;
  googleButtonClassName?: string;
};

export function AuthActions({
  className,
  onSubmit,
  onSubmitWithGoogle,
  isSubmitting,
  isLoading,
  isValid,
  submitLabel,
  googleLabel,
  isWithBorder = true,
  isWithPadding = true,
  signupButtonClassName,
  googleButtonClassName,
}: Props) {
  const isLoadingOrSubmitting = isLoading || isSubmitting;

  return (
    <div
      className={twMerge(
        "flex flex-col items-start gap-3 transition-opacity duration-200",
        isWithBorder && "border-t border-brand-800",
        isWithPadding && "px-8 py-4",
        isLoadingOrSubmitting && "opacity-20 bg-brand-50",
        className
      )}
    >
      <Button
        variant="primary"
        theme="light"
        onClick={onSubmit}
        disabled={isSubmitting || isLoading || !isValid}
        className={signupButtonClassName}
      >
        {submitLabel}
      </Button>
      <GoogleButton
        label={googleLabel}
        onClick={onSubmitWithGoogle}
        className={googleButtonClassName}
      />
    </div>
  );
}

export default AuthActions;
